<template>
  <div class="bg-grayDark-100">
    <div class="bg-white">
      <div class="p-4">
        <h1 class="font-semibold">{{ __('Order and download materials free of charge') }}</h1>
      </div>
    </div>
    <div class="px-4 py-10 mx-auto md:w-1/4">
      <h3 class="mb-4 text-2xl font-medium" style="color: #989898;">{{ __('Select treatment area') }}</h3>
      <ul class="grid gap-4">
        <li v-for="category in categories" :key="category.id">
          <Link :href="'/shop?parent_category='+category.id">
            <div class="flex items-center">
              <div class="truncate">
                <div class="flex" style="font-size: 15px">
                  <p class="font-medium truncate text-dark-100">{{ category.name }}</p>
                  <p class="flex-shrink-0 ml-1 font-normal text-gray-500"> ( {{ category.products }} ) </p>
                </div>
              </div>
              <div class="ml-1 text-sm">
                >
              </div>
            </div>
          </Link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {Link} from '@inertiajs/inertia-vue3'

export default {
  name: 'Categories',
  components: {
    Link,
  },
  props: {
    categories: {
      type: [Array, Object],
      required: true,
    },
  },
}
</script>
